<div class="sidebar" [class.collapsed]="isCollapsed()">
  <!-- HEADER -->
  <div class="header">
    @if (!isCollapsed()) {
    <div class="logo">
      <div class="icon-circle">
        <i class="bi bi-graph-up-arrow"></i>
      </div>
      <div class="title">
        <h2>KPI</h2>
        <span>Manager</span>
      </div>
    </div>
    } @if (isCollapsed()) {
    <div class="logo-collapsed">
      <div class="icon-circle">
        <i class="bi bi-graph-up-arrow"></i>
      </div>
    </div>
    }
  </div>

  <hr class="divider" />

  <!-- Collapse Button -->
  <button class="collapse-btn" (click)="toggleSidebar()">
    <i
      class="bi"
      [class.bi-chevron-left]="!isCollapsed()"
      [class.bi-chevron-right]="isCollapsed()"
    ></i>
  </button>

  <!-- MAIN MENU -->
  <nav class="menu">
    @if (!isCollapsed()) {
    <p class="section-title">MENÚ PRINCIPAL</p>
    } @for (item of menu(); track item.path) {
    <a [routerLink]="item.path" routerLinkActive="active" class="menu-item" (click)="onMenuClick()">
      <div class="icon">
        <i class="bi" [ngClass]="item.icon"></i>
      </div>

      @if (!isCollapsed()) {
      <span class="label">{{ item.label }}</span>
      }
    </a>
    }
  </nav>

  <!-- USER FOOTER -->
  @if (!isCollapsed()) {
  <div class="user-card">
    <div class="photo-circle">
      <i class="bi bi-person"></i>
    </div>

    <div class="user-info">
      <strong class="nombre">{{ user()?.name }}</strong>
    </div>

    <!-- Botón logout -->
    <button class="logout-btn" (click)="logout()">
      <i class="bi bi-box-arrow-right"></i>
    </button>
  </div>

  } @if (isCollapsed()) {
  <div class="user-card-collapsed">
    <div class="photo-circle">
      <i class="bi bi-person"></i>
    </div>
  </div>
  }
</div>
